import { Typography, useTheme } from "@mui/material"

export function Unassigned() {
    const theme = useTheme()
    return (
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary, width: "100%" }}>
            —
        </Typography>
    )
}
